import { DataTableDesignTokens } from '@primeuix/themes/types/datatable';
import {variablesPreset} from './variables.preset';

export const dataTablePreset: DataTableDesignTokens = {
  headerCell: {
    background: variablesPreset['tint-turquoise-4']
  },
  header: {
    background: variablesPreset['tint-turquoise-4']
  }
}
